import { render } from "./App.vue?vue&type=template&id=42e19196"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./App.vue?vue&type=style&index=1&id=42e19196&lang=scss"
script.render = render

export default script